import { render, staticRenderFns } from "./BeltInfo.vue?vue&type=template&id=d76c8398&scoped=true"
import script from "./BeltInfo.vue?vue&type=script&lang=js"
export * from "./BeltInfo.vue?vue&type=script&lang=js"
import style0 from "./BeltInfo.vue?vue&type=style&index=0&id=d76c8398&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76c8398",
  null
  
)

export default component.exports